export function deferred<T>() {
  let ready: (result: T) => void;
  let dispose: () => void;
  const promise = new Promise<{ value: T | null; isCancelled: boolean }>(
    (res, rej) => {
      ready = (value) => res({ value, isCancelled: false });
      dispose = () => res({ value: null, isCancelled: true });
    },
  );
  return Object.assign(promise, { ready, dispose });
}
